export const environment = {
    production : true,
    gatewayUrl : "https://deeshagatewaydev.azurewebsites.net/api",
    azure : {
        clientId : "d7bed9cd-5384-4034-bac4-c5ca36ebd557", //DeeshaPowerBIembedded
        authority: "https://login.microsoftonline.com/common",
        redirectUri : "https://deeshawebdev.azurewebsites.net/userCenter",
        postLogoutRedirectUri : "https://deeshawebdev.azurewebsites.net/login"
    },
    BackendDomain : "deeshagatewaydev.azurewebsites.net"
}